import React from 'react'
import { Link } from 'react-router-dom'
import { RichText as PrismicRichText } from 'prismic-reactjs'
import { HeroSlice } from 'modules/prismic'
import { Carousel } from 'components/Slider'
import { Slide } from 'pure-react-carousel'
import { SliderWrapper } from 'app/sofia/scenes/Home/components/Slider/styled'
import { useIsMobile } from 'hooks/responsive'
import { Wrapper } from './styled'

export const Hero = ({ items }: HeroSlice) => {
  const isMobile = useIsMobile()
  const isSingleItem = items.length === 1

  if (isSingleItem) {
    return <HeroItem {...items[0]} />
  }

  return (
    <SliderWrapper>
      <Carousel
        child={items}
        renderChildren={(children: any[]) => {
          return children.map((child: any, index: number) => {
            return (
              <Slide index={index} key={index}>
                <HeroItem {...child} />
              </Slide>
            )
          })
        }}
        autoPlay
        arrowsEnabled={items?.length > 1 && !isMobile}
        autoHeight
      />
    </SliderWrapper>
  )
}

const HeroItem = ({
  background_image: backgroundImage,
  background_image_mobile: backgroundImageMobile,
  hero_title: title,
  hero_subtitle: subtitle,
  hero_content: content,
  button_label: buttonLabel,
  button_url: buttonUrl,
  text_alignment: textAlignment
}: HeroSlice['items'][0]) => {
  const isMobile = useIsMobile()

  return (
    <Wrapper textAlignment={textAlignment}>
      {!isMobile ? (
        <>
          {backgroundImage.url && (
            <div className='image-wrapper'>
              <img src={backgroundImage.url} alt={backgroundImage.alt ?? ''} />
            </div>
          )}
        </>
      ) : (
        <>
          <div className='image-wrapper'>
            <img src={backgroundImageMobile.url ?? backgroundImage.url} alt={backgroundImageMobile.alt ?? ''} />
          </div>
        </>
      )}
      <div className='container'>
        <div className='content'>
          {title.length && (
            <>{PrismicRichText.render(title)}</>
          )}
          {subtitle.length && (
            <>{PrismicRichText.render(subtitle)}</>
          )}
          {content.length && (
            <>{PrismicRichText.render(content)}</>
          )}
          {buttonLabel && buttonUrl && (
            <Link to={buttonUrl} className='btn btn-lg'>
              {buttonLabel}
            </Link>
          )}
        </div>
      </div>
    </Wrapper>
  )
}
